<div class="content">
  <div class="content__close" (click)="onNoClick()">
    <img src="../../../assets/img/icons/close-white-bg.png">
  </div>
  <div class="content__container">
    <h3 class="content__container__title">{{data.title}}</h3>
    @if (data.selectedProducts && (data.selectedProducts.length === 1)) {
      <p class="content__container__padding"></p>
    }
    @if (data.selectedProducts && (data.selectedProducts.length > 1)) {
      <div class="content__container__text">
        <div class="content__container__text__items">
          <p class="content__container__text__items__item">{{data.text}}</p>
          <button (click)="continue()" class="content__container__text__items__item__btn">Yes</button>
          <button (click)="onNoClick()" class="content__container__text__items__item__btn">No</button>
        </div>
      </div>
    }
  </div>
</div>
